import { useEffect } from 'react';
import { useAuthenticateMutation } from 'api';

export const useAuth = () => {
  const [authenticate, { isLoading, isSuccess }] = useAuthenticateMutation();

  useEffect(() => {
    authenticate();
  }, [authenticate]);

  return {
    isLoading,
    isSuccess,
  };
};
